import{signOut as e}from"aws-amplify/auth";async function t(){try{await e()}catch(e){console.error(`Error clearing auth session:`,e)}}export{t as clearAuthSession};
//# sourceMappingURL=clear-auth-session.mjs.map